import * as React from "react";
function SvgGenderMale(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.071 7.343v1.829h2V3.929h-5.243v2h1.829l-4.009 4.008a6.002 6.002 0 00-7.72 9.134 6 6 0 009.135-7.72l4.008-4.008zM12 12a4 4 0 10-5.657 5.657A4 4 0 0012 12z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgGenderMale);
export default ForwardRef;
